import { Flex, Group, Title } from "@mantine/core";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { ExternalCheckQueue } from "@/components/features/CheckInOut/ExternalCheckQueue";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { useRequestScope } from "@/hooks/useRequestScope";
import { tableSearchSchema } from "@/hooks/useTableUrlPersistence";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

import styles from "./check-in-out.module.scss";

const checkInOutSearchSchema = tableSearchSchema.extend({
  tab: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authenticated/check-in-out/")({
  component: CheckInOut,
  validateSearch: checkInOutSearchSchema.parse,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function CheckInOut() {
  const searchParams = useSearch({ from: "/_authenticated/check-in-out/" });
  const requestScope = useRequestScope();

  useBreadcrumb(
    [
      {
        title: "Check-in/out",
        href: "/check-in-out",
        icon: getRouteIcon(MODULE_KEYS_MAP.checkInOut),
      },
    ],
    { listView: "List View" },
  );

  return (
    <Flex direction="column" className={styles.container}>
      <Group justify="space-between" align="center" className={styles.header}>
        <Title order={3} className={styles.title}>
          Check-in/out
        </Title>
      </Group>

      <ExternalCheckQueue key={requestScope} searchParams={searchParams} />
    </Flex>
  );
}
